import React, { useState, useEffect } from "react";

import ReactTable from "react-table";
import "react-table/react-table.css";


const ClientSideTable = props => {
    console.log(props.data)

    const [rows, setRows] = useState([]);
    const [cols, setCols] = useState([]) 

    useEffect(() => {
        if(props.data) {
            if(props.data.cols) {
                setCols(props.data.cols.map(col => {
                    if(col === "name") {
                        return ({
                            Header: col,
                            accessor: col,
                            className: "text-center",
                            headerClassName: "react-table-header-class"
                        })
                    }
                    return ({
                        Header: col,
                        accessor: col,
                        className: "text-center",
                        headerClassName: "react-table-header-class"
                    })
                }));
                setRows(props.data.rows);
            }
        }
    }, [props.data])

    return (
        <div className="roe-card-style mt-15 mb-30">
            <div className="roe-card-header" style={{textAlign:"center", textTransform:"uppercase", fontSize:"3em", fontWeight:"bold"}}>
               {props.data ? props.data.name : ""}
            </div>
            <div className="roe-card-body">
                {/* You can take this configuration for react table customization */}
                <ReactTable
                    data={rows}
                    columns={cols}
                    defaultPageSize={10}
                    filterable
                    defaultFilterMethod={(filter, row) => {
                        const id = filter.pivotId || filter.id;
                        return row[id] !== undefined
                            ? String(
                                row[id].toLowerCase()
                            ).includes(filter.value.toLowerCase())
                            : true;
                    }}
                    className="-striped -highlight custom-react-table-theme-class"
                />
                {/* You can take this configuration for react table customization */}
            </div>
        </div>
    );
};

export default ClientSideTable;
